import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_END_POINT_API || "https://api.zarpar-beta.net",
});

api.interceptors.request.use(
  (config) => {
    // Add ngrok header
    config.headers["ngrok-skip-browser-warning"] = "true";

    // Add Authorization header if token exists
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    // Ensure JSON content type
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
